import ProposalInvalidToken from "./screens/ProposalInvalidToken";
import ProposalValidToken from "./screens/ProposalValidToken";
import SearchProposals from "./screens/ProposalsSearch";
import ProposalsViewInfo from "./screens/ProposalsViewInfo";
import ProposalDone from "./screens/ProposalDone";

// eslint-disable-next-line react-refresh/only-export-components
export const ProposalsScreens = {
  Search: SearchProposals,
  ViewInfo: ProposalsViewInfo,
  ValidToken: ProposalValidToken,
  InvalidToken: ProposalInvalidToken,
  ProposalDone
};

export default ProposalsScreens;
